var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.37198,
    cy: 3.32901,
    r: 2.59854,
    fill: "#E1E5EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyTick);
export default __webpack_public_path__ + "static/media/grey-tick.bdedd2c3d88b49cf2e241ef80bf54a77.svg";
export { ForwardRef as ReactComponent };